import { mediaUrls } from 'globalconfig/constants/mediaUrls';

const leftMenu = [
  {
    icon: mediaUrls.feedback,
    label: 'leftMenu.feedback',
    roles: ['FLMANAGER', 'ADMIN', 'DRIVER', 'MECHANIC'],
    path: '/feedback'
  }
];
export default leftMenu;
